module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/es-ca-a03129ff81e9f5633e7501e84ad38e4d.svg";